import { HiStar } from "react-icons/hi2";

export const FilledStarIcon = ({ width, height, color, ...props }) => (
  <HiStar
    size={width || height || 24}
    color={color || "currentColor"}
    className="fill-current"
    {...props}
  />
);
